var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"ui-logo",style:({ width: _vm.width, height: _vm.height }),attrs:{"src":require(("@/assets/img/logo/" + _vm.logo))}})}
var staticRenderFns = []

export { render, staticRenderFns }